module.exports = __webpack_public_path__ + "static/media/8_sharing.9d170f17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/product/8_sharing.jpg
// module id = 324
// module chunks = 0